<template>
  <ul class="content">
    <li class="service_content" v-for="(item, index) in list" :key="index" @click="cbDetail(item)">
        <p class="service_title">{{item.title}}</p>
        <p v-if="item.summary" class="service_summary __ellipsis __line2">{{item.summary}}</p>
        <img v-if="item.src" class = "service_img" :src="formatAliyunPath(item.src)"/>
    </li>
  </ul>
</template>

<script>
import { aliyun } from '@/agent'
export default {
  name: 'NewsList',
  props: {
    list: {
      type: Array
    }
  },
  data () {
    return {
    }
  },
  methods: {
    cbDetail (item) {
      this.$router.push({
        path: '/building/detail',
        query: {
          id: item.id,
          type: 'service',
        }
      })
    },
    // 格式化阿里云地址
    formatAliyunPath (path) {
      return aliyun.getAliyunAddress(path)
    },
  }
}
</script>

<style lang="scss" scoped>
  .content {
    width: 100%;
    height: 100%;
    overflow: auto;
    &::-webkit-scrollbar {
      display: none;
    }
    .service_content{
      padding: 24px 24px 0 24px;
      box-sizing: border-box;
      .service_title {
        width: 100%;
        opacity: 1;
        font-size: 17px;
        font-family: Source Han Sans CN, Source Han Sans CN-Regular;
        font-weight: 400;
        text-align: left;
        color: #1c1f25;
        line-height: 24px;
        overflow: hidden; // 文字超过三行省略号处理
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
      }
      .service_summary {
        margin-top:12px;
        opacity: 1;
        font-size: 12px;
        font-family: Source Han Sans CN, Source Han Sans CN-Regular;
        font-weight: 400;
        text-align: left;
        color: #828282;
        line-height: 18px;
        overflow: hidden; // 文字超过三行省略号处理
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .service_img {
        width: 100%;
        height: 161px;
        display: block;
        opacity: 1;
        margin-top: 12px;
      }
    }
  }
</style>
